import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import {
  AccountUpdatePasswordRequestBody,
  AccountUpdatePasswordResponse,
} from "./types";

export class AccountUpdatePasswordAPI extends BaseAPI<
  AccountUpdatePasswordRequestBody,
  AccountUpdatePasswordResponse
> {
  protected route = ApiRoutes.account.update_password;
  protected method = RequestMethod.POST;
}
